import { render } from "./sharing_settings.vue?vue&type=template&id=4b9643e5&ts=true"
import script from "./sharing_settings.vue?vue&type=script&lang=ts"
export * from "./sharing_settings.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__